import React, { useState } from "react";
import constant from "../../../constant";
import moment from "moment";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import Loader from "../../common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";

const GovtJobResultList = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  const location = useLocation();
  const Navigate = useNavigate();
  const [govtResultFullDetails, setGovtResultFullDetails] = useState({});
  const handlePageChange = (pageNumber) => {
    Navigate(location.pathname + "?p=" + pageNumber);
    setCurrentPage(pageNumber);
    props.getGovtJobsLists(pageNumber);
  };
  const updateStatus = (GOVT_RESULT_ID, STATUS) => {
    const model = {
        GOVT_RESULT_ID: GOVT_RESULT_ID,
      STATUS: STATUS === "A" ? "U" : "A",
    };
    props.updateStatus(model);
    props.setPage(currentPage);
  };

  // const searchList = () => {
  //     props.getGovtJobList(currentPage)
  // }

  const qParams = queryString.parse(location.search);
  const { cpage } = props;

  return (
    <React.Fragment>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 " style={{ fontSize: "18px" }}>
                    Government Jobs Result List
                  </h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">Utilities</a>
                      </li>
                      <li className="breadcrumb-item active">
                        Government Jobs Result List
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form className="row gy-12 gx-12 align-items-center">
                                            <div className="col-sm-2">
                                                <label className="visually-hidden" for="autoSizingInput">Name</label>
                                                Search Government Job
                                            </div>
                                            <div className="col-sm-6">
                                                <label className="visually-hidden" for="autoSizingInputGroup">Username</label>
                                                <div className="input-group">
                                                    <input type="text" onChange={(e) => {
                                                        props.keyword(e.target.value)
                                                    }} className="form-control" id="autoSizingInputGroup" placeholder="Enter Government Job" />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <button type="submit" onClick={(e) => {
                                                    e.preventDefault()
                                                    searchList()
                                                }} className="btn btn-success waves-effect btn-label waves-light"><i className="bx bx-check-double label-icon"></i> Search</button>&nbsp;
                                                <button type="button" className="btn btn-outline-danger">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div> */}
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table align-middle table-nowrap table-hover">
                        {props.showLoader && <Loader />}
                        {!props.showLoader && (
                          <thead className="table-light">
                            <tr>
                              <th scope="col">S.No.</th>
                              <th scope="col">Govt. Result Title</th>
                              <th scope="col">Job Result URL</th>
                              <th scope="col">Added On</th>
                              <th scope="col">Status</th>
                              <th scope="col" style={{ width: "100px" }}>
                                Action
                              </th>
                            </tr>
                          </thead>
                        )}
                        <tbody>
                          {props.list &&
                            props.list.length > 0 &&
                            props.list.map((ele, index, list) => {
                              return (
                                <tr>
                                  <td>
                                    {currentPage == 1
                                      ? `${index + 1}`
                                      : `${
                                          index == 9
                                            ? currentPage
                                            : currentPage - 1
                                        }` + `${index == 9 ? 0 : index + 1}`}
                                  </td>
                                  {/* <td>{ele.GOVT_DEPT_ID}</td> */}
                                  <td>
                                    <h5 className=" mb-0">{ele.RESULT_TITLE?.length<=30?ele.RESULT_TITLE:(ele.RESULT_TITLE?.slice(0,30))+'..'}</h5>
                                    <p>
                                    {ele.CATEGORY !== "CENTRAL"?  ( <>{ele.STATE} </>):'Central Government Job'  }
                                     
                                    
                                    </p>
                                  </td>
                                  <td>
                                    <a target='_blank' href={ele.RESULT_URL}><button type="button"
                                                    className="btn btn-success">Apply Now</button></a>
                                  </td>
                                  <td>
                                    <a
                                      type="button"
                                      data-bs-toggle="modal"
                                      //data-bs-target="#staticBackdrop4"
                                      data-bs-target="#staticBackdrop4"
                                      className="btn btn-info waves-effect btn-label waves-light"
                                      // onClick={() => (govtJobFullDetails.CANDIDATE_ID)}>
                                      onClick={(e) => {
                                        setGovtResultFullDetails(ele);
                                      }}
                                    >
                                      <i className="bx bx-street-view label-icon "></i>{" "}
                                      View Details
                                    </a>
                                  </td>
                                  <td>
                                    {ele.STATUS == "U" ? (
                                      <button
                                        type="button"
                                        className="btn btn-success btn-sm waves-effect waves-light"
                                      >
                                        ACTIVE
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm waves-effect waves-light"
                                      >
                                        ARCHIVE
                                      </button>
                                    )}
                                  </td>
                                  <td>
                                    <ul className="list-inline font-size-20 contact-links mb-0">
                                      <li className="list-inline-item px-2">
                                        <Link
                                          to={constant.component.editgovtresult.url
                                            .replace(":id", ele.GOVT_RESULT_ID)
                                            .replace(":pageno", cpage)}
                                          title="Edit Govt Result"
                                        >
                                          <i className="bx bx-edit"></i>
                                        </Link>{" "}
                                      </li>
                                      <li className="list-inline-item px-2">
                                        <a
                                          href="javascript: void(0);"
                                          onClick={() =>
                                            updateStatus(
                                              ele.GOVT_RESULT_ID,
                                              ele.STATUS
                                            )
                                          }
                                          style={{ color: "red" }}
                                          title={
                                            ele.STATUS == "U"
                                              ? "Archive Record"
                                              : "Unarchive Record"
                                          }
                                        >
                                          {ele.STATUS == "U" ? (
                                            <i className="bx bx-trash"></i>
                                          ) : (
                                            <i class="bx bx-log-in"></i>
                                          )}
                                        </a>
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                              );
                            })}
                          {
                            <>
                              {props.list &&
                                props.list.length == 0 &&
                                props.showLoader == false && (
                                  <td
                                    colSpan={10}
                                    className="text-center text-danger pt-3"
                                  >
                                    No Record Found
                                  </td>
                                )}
                            </>
                          }
                          <div
                            className="modal fade"
                            id="staticBackdrop4"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="staticBackdropLabel"
                            aria-hidden="true"
                          >
                            <div
                              className="modal-dialog modal-dialog-centered modal-lg"
                              role="document"
                            >
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="staticBackdropLabel"
                                  >
                                    Job Details - {govtResultFullDetails.RESULT_TITLE}
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <p>
                                    {govtResultFullDetails && (
                                      <table className="table table-striped mb-0 job-details-table skills-data-table">
                                        <tbody>
                                        
                                        <tr>
                                            <td>Job Category</td>
                                            <td>
                                              {govtResultFullDetails.CATEGORY
                                                ? govtResultFullDetails.CATEGORY
                                                : "Not Available"}
                                            </td>
                                          </tr>
                                          
                                        <tr>
                                            <td>Department</td>
                                            <td>
                                              {govtResultFullDetails.DEPARTMENT
                                                ? govtResultFullDetails.DEPARTMENT
                                                : "Not Available"}
                                            </td>
                                          </tr>
                                         
                                          
                                          
                                          
                                          
                                          

                                          
                                          <tr>
                                            <td>Created On</td>
                                            <td>
                                            
                                      {moment(govtResultFullDetails.CREATED_ON).format(
                                        "DD.MM.YYYY hh:mma"
                                      )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Description</td>
                                            <td>
                                            
                                      {govtResultFullDetails.DESCRIPTION}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    )}
                                  </p>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <ul className="pagination pagination-rounded justify-content-center mt-4">
                          <Pagination
                            activePage={
                              qParams?.p
                                ? +qParams?.p
                                : qParams?.pageno
                                ? Number(qParams.pageno)
                                : currentPage
                            }
                            itemsCountPerPage={10}
                            totalItemsCount={props.count}
                            pageRangeDisplayed={10}
                            onChange={handlePageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default GovtJobResultList;
